export function resetLogin() {
  return {
    type: 'RESET_LOGIN'
  }
}
